// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__CDtue","signatureBlock":"Footer_signatureBlock___jk0w","signature":"Footer_signature__3Xj3O"};